const faqItems = [
  {
    q: '漫蛙漫画网的漫画是免费的吗？',
    a: '是的！漫蛙漫画网上的所有漫画资源均免费提供在线阅读，无需付费订阅即可畅享海量韩漫、日漫、国漫内容。我们致力于为漫画爱好者打造一个零门槛的阅读平台。',
  },
  {
    q: '漫画更新频率是怎样的？',
    a: '我们每天同步更新热门连载漫画，确保你能第一时间看到最新章节。完结漫画也会定期整理上架，方便你随时重温经典作品。韩漫和国漫更新尤其迅速。',
  },
  {
    q: '支持手机阅读吗？',
    a: '完全支持！漫蛙漫画网采用响应式设计，完美适配手机、平板和电脑等各类设备。无论你用什么设备，都能享受高清流畅的在线阅读体验，随时随地看漫画。',
  },
  {
    q: '如何找到我想看的漫画类型？',
    a: '你可以通过首页的专题合集按题材分类浏览，也可以在热门话题中发现当下最火的漫画。我们还提供人气榜单和编辑推荐，帮助你快速找到好看的漫画。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50 scroll-mt-header">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">常见问题</h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">关于漫蛙漫画的常见疑问，这里都有答案</p>
        </div>

        <div className="max-w-3xl mx-auto space-y-3">
          {faqItems.map((item) => (
            <div
              key={item.q}
              className="bg-background-100 rounded-xl p-5 md:p-6 border border-background-200/70"
            >
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-900 mb-3 flex items-start gap-3">
                <span className="w-6 h-6 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0 mt-0.5">
                  <i className="ri-question-line text-xs text-primary-500"></i>
                </span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed pl-9">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}